export enum ProductEnum {
    FamAnnualMembership = "FAM_ANUAL_MEMBERSHIP",
    Donation = "DONATION",
    Discount = "DISCOUNT_DARF"
}